<!-- Category methods -->
@if (data && (!data.isChild || (data.isChild && data.subCategory))) {
  <div [attr.auto-qa]="autoTestAttribute">
    <!-- Method if driver=site -->
    @if (data.driver === 'DRIVER_SITE') {
      <aux-forecast-table-grid-method-site
        [placeholder]="componentParent.checkService.formControlConstants.PLACEHOLDER.SELECT"
        [isChild]="false"
        [onMethodChange]="componentParent.onMethodChange"
        [categoryId]="data.id"
        [primarySettingsId]="data.primarySettingsId"
        [disabled]="
          !data.primarySettingsOverride ||
          disableMethod ||
          componentParent.isForecastFinalized ||
          componentParent.isClosedMonthsProcessing ||
          !componentParent.isSiteDriverAvailable
        "
        [tooltip]="
          componentParent.checkService.tooltipText(
            componentParent.isForecastFinalized || componentParent.isClosedMonthsProcessing,
            componentParent.userHasModifyPermissions
          )
        "
        [isInvalid]="
          (componentParent.checkService.isShowError(data.primarySettingsId) | async) ||
          (componentParent.checkService.isCategoryUnforecasted(data.primarySettingsId) | async) ||
          false
        "
        [driverSettingId]="data.driverSettingId"
        [siteCurves]="componentParent.siteCurves"
      />
    }

    <!-- Method if driver=patient -->
    @if (data.driver === 'DRIVER_PATIENT') {
      <aux-forecast-table-grid-method-patient
        [placeholder]="componentParent.checkService.formControlConstants.PLACEHOLDER.SELECT"
        [isChild]="false"
        [onMethodChange]="componentParent.onMethodChange"
        [categoryId]="data.id"
        [primarySettingsId]="data.primarySettingsId"
        [disabled]="
          componentParent.isForecastFinalized ||
          componentParent.isClosedMonthsProcessing ||
          disableMethod
        "
        [tooltip]="
          componentParent.checkService.tooltipText(
            componentParent.isForecastFinalized || componentParent.isClosedMonthsProcessing,
            componentParent.userHasModifyPermissions
          )
        "
        [isInvalid]="
          (componentParent.checkService.isShowError(data.primarySettingsId) | async) ||
          (componentParent.checkService.isCategoryUnforecasted(data.primarySettingsId) | async) ||
          false
        "
        [selectedPatientCurve]="data.driverSettingId"
        [patientCurves]="componentParent.patientCurves"
      />
    }

    <!-- Method if driver=time -->
    @if (data.driver === 'DRIVER_TIME') {
      <aux-forecast-table-grid-method-time
        [placeholder]="componentParent.checkService.formControlConstants.PLACEHOLDER.SELECT"
        [isChild]="false"
        [onMethodChange]="componentParent.onMethodChange"
        [categoryId]="data.id"
        [primarySettingsId]="data.primarySettingsId"
        [disabled]="
          !data.primarySettingsOverride ||
          disableMethod ||
          componentParent.isForecastFinalized ||
          componentParent.isClosedMonthsProcessing
        "
        [tooltip]="
          componentParent.checkService.tooltipText(
            componentParent.isForecastFinalized || componentParent.isClosedMonthsProcessing,
            componentParent.userHasModifyPermissions
          )
        "
        [isInvalid]="
          (componentParent.checkService.isShowError(data.primarySettingsId) | async) ||
          (componentParent.checkService.isCategoryUnforecasted(data.primarySettingsId) | async) ||
          false
        "
        [selectedForecastMethod]="data.method"
        [methodOptions]="componentParent.methodService.MethodOptions"
      />
    }

    @if (data.driver === 'DRIVER_CUSTOM') {
      <aux-forecast-table-grid-method-custom-curve
        [isInvalid]="
          (componentParent.checkService.isShowError(data.primarySettingsId) | async) ||
          (componentParent.checkService.isCategoryUnforecasted(data.primarySettingsId) | async) ||
          false
        "
        [disabled]="
          componentParent.isForecastFinalized ||
          componentParent.isClosedMonthsProcessing ||
          disableMethod
        "
        [tooltip]="
          componentParent.checkService.tooltipText(
            componentParent.isForecastFinalized || componentParent.isClosedMonthsProcessing,
            componentParent.userHasModifyPermissions
          )
        "
        [onMethodChange]="componentParent.onMethodChange"
        [categoryId]="data.id"
        [primarySettingsId]="data.primarySettingsId"
        [selectedCurve]="data.driverSettingId"
        [customCurves]="componentParent.customCurves()"
      />
    }
  </div>
}

@if (data && data.isChild && !data.subCategory) {
  <div>
    <!-- Method if driver=site -->
    @if (data.driver === 'DRIVER_SITE') {
      <aux-forecast-table-grid-method-site
        [placeholder]="componentParent.checkService.formControlConstants.PLACEHOLDER.SELECT"
        [isChild]="true"
        [onMethodChange]="componentParent.onMethodChange"
        [categoryId]="data.id"
        [primarySettingsId]="data.primarySettingsId"
        [disabled]="
          (data.parentCategory?.primarySettingsOverride && !data.primarySettingsOverride) ||
          componentParent.isForecastFinalized ||
          componentParent.isClosedMonthsProcessing ||
          disableMethod ||
          !componentParent.isSiteDriverAvailable
        "
        [tooltip]="
          componentParent.checkService.tooltipText(
            componentParent.isForecastFinalized || componentParent.isClosedMonthsProcessing,
            componentParent.userHasModifyPermissions
          )
        "
        [isInvalid]="
          (componentParent.checkService.isShowError(data.primarySettingsId) | async) ||
          (componentParent.checkService.isActivityUnforecasted(data.id) | async) ||
          false
        "
        [driverSettingId]="data.driverSettingId"
        [siteCurves]="componentParent.siteCurves"
      />
    }

    <!-- Method if driver=patient -->
    @if (data.driver === 'DRIVER_PATIENT') {
      <aux-forecast-table-grid-method-patient
        [placeholder]="componentParent.checkService.formControlConstants.PLACEHOLDER.SELECT"
        [isChild]="true"
        [onMethodChange]="componentParent.onMethodChange"
        [categoryId]="data.id"
        [primarySettingsId]="data.primarySettingsId"
        [disabled]="
          componentParent.isForecastFinalized ||
          componentParent.isClosedMonthsProcessing ||
          disableMethod
        "
        [tooltip]="
          componentParent.checkService.tooltipText(
            componentParent.isForecastFinalized || componentParent.isClosedMonthsProcessing,
            componentParent.userHasModifyPermissions
          )
        "
        [isInvalid]="
          (componentParent.checkService.isShowError(data.primarySettingsId) | async) ||
          (componentParent.checkService.isActivityUnforecasted(data.id) | async) ||
          false
        "
        [selectedPatientCurve]="data.driverSettingId"
        [patientCurves]="componentParent.patientCurves"
      />
    }

    <!-- Method if driver=time -->
    @if (data.driver === 'DRIVER_TIME') {
      <aux-forecast-table-grid-method-time
        [placeholder]="componentParent.checkService.formControlConstants.PLACEHOLDER.SELECT"
        [isChild]="true"
        [onMethodChange]="componentParent.onMethodChange"
        [categoryId]="data.id"
        [primarySettingsId]="data.primarySettingsId"
        [disabled]="
          (data.parentCategory?.primarySettingsOverride && !data.primarySettingsOverride) ||
          disableMethod ||
          componentParent.isForecastFinalized ||
          componentParent.isClosedMonthsProcessing
        "
        [tooltip]="
          componentParent.checkService.tooltipText(
            componentParent.isForecastFinalized || componentParent.isClosedMonthsProcessing,
            componentParent.userHasModifyPermissions
          )
        "
        [isInvalid]="
          (componentParent.checkService.isShowError(data.primarySettingsId) | async) ||
          (componentParent.checkService.isActivityUnforecasted(data.id) | async) ||
          false
        "
        [selectedForecastMethod]="data.method"
        [methodOptions]="componentParent.methodService.MethodOptions"
      />
    }

    @if (data.driver === 'DRIVER_CUSTOM') {
      <aux-forecast-table-grid-method-custom-curve
        [isInvalid]="
          (componentParent.checkService.isShowError(data.primarySettingsId) | async) ||
          (componentParent.checkService.isCategoryUnforecasted(data.primarySettingsId) | async) ||
          false
        "
        [disabled]="
          componentParent.isForecastFinalized ||
          componentParent.isClosedMonthsProcessing ||
          disableMethod
        "
        [tooltip]="
          componentParent.checkService.tooltipText(
            componentParent.isForecastFinalized || componentParent.isClosedMonthsProcessing,
            componentParent.userHasModifyPermissions
          )
        "
        [onMethodChange]="componentParent.onMethodChange"
        [categoryId]="data.id"
        [isChild]="true"
        [primarySettingsId]="data.primarySettingsId"
        [selectedCurve]="data.driverSettingId"
        [customCurves]="componentParent.customCurves()"
      />
    }
  </div>
}
